import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../routers/AppRoute";

export const initialState = {
  loading: false,
  hasErrors: false,
  getAllMenuMailData: [],
};

// A slice for recipes with our three reducers
const getAllMenuMailDataSlice = createSlice({
  name: "getAllMenuMailData",
  initialState,
  reducers: {
    getAllMenuMailData: (state) => {
      state.loading = true;
    },
    getAllMenuMailDataSuccess: (state, { payload }) => {
      state.getAllMenuMailData = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getAllMenuMailDataFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
  },
});

// Three actions generated from the slice
export const {
  getAllMenuMailData,
  getAllMenuMailDataSuccess,
  getAllMenuMailDataFailure,
} = getAllMenuMailDataSlice.actions;

// A selector
export const getAllMenuMailDataSelector = (state: {
  getAllMenuMailData: any;
}) => state.getAllMenuMailData;

// The reducer
export default getAllMenuMailDataSlice.reducer;

// Asynchronous thunk action
// export function fetchgetAllMenuData() {
//   return async (dispatch: any) => {
//     dispatch(getAllMenuData());
//     try {
//       const URL = BASE_URL + `/GetAllMenu`;
//       const response: any = await axios.get(URL);
//       var jsonData = response.data;
//       // console.log(jsonData, "$$$$$$4$$$$$$$$$$$$$");

//       // const newjsonData = jsonData?.find((obj: any) => obj.name == "CON_USER");
//       // console.log(newjsonData.subMenu, "newjsonData%%%%%%%%%%%%%%%%%%%%%%%");
//       dispatch(getAllMenuDataSuccess(jsonData[0].subMenu));
//     } catch (error) {
//       dispatch(getAllMenuDataFailure());
//     }
//   };
// }

export function fetchgetAllMenuDataForEmail() {
  return async (dispatch: any) => {
    dispatch(getAllMenuMailData());
    try {
      const URL = BASE_URL + `/GetAllMenu`;
      const response2: any = await axios.get(URL);
      var jsonData = response2.data;
      // console.log(jsonData?.name, "$$$$$$4$$$$$$$$$$$$$");
      const newjsonData = jsonData?.find((obj: any) => obj.name == "CON_USER");
      // console.log(newjsonData.subMenu, "newjsonData%%%%%%%%%%%%%%%%%%%%%%%");
      dispatch(getAllMenuMailDataSuccess(newjsonData.subMenu));
    } catch (error) {
      dispatch(getAllMenuMailDataFailure());
    }
  };
}
